import { getAuthCookieInfo } from 'utils/functions/authentication';
import { fetchLoginInfo } from 'modules/labs/accountManagement/actions';

const initApp = dispatch => {
  const { userKey } = getAuthCookieInfo();

  const body = {
    userKey,
  };

  dispatch(fetchLoginInfo(body));
};

export default initApp;
